import { render, staticRenderFns } from "./FluxP2I.vue?vue&type=template&id=3ef5a346&scoped=true"
import script from "./FluxP2I.vue?vue&type=script&lang=js"
export * from "./FluxP2I.vue?vue&type=script&lang=js"
import style0 from "./FluxP2I.vue?vue&type=style&index=0&id=3ef5a346&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef5a346",
  null
  
)

export default component.exports